<template>
    <div class="grow-conversation">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="content-lg">
                        <SectionHeader title="Grow Your Conversions With CrossProm"/>
                        <div class="grow-item-container d-flex flex-wrap justify-content-xl-between justify-content-center align-items-center">
                            <GrowItem v-for="item in conversionData" :key="item.desc" :data="item"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GrowItem from './GrowItem'
import SectionHeader from '../SectionHeader'
import {conversionData} from '../landingPageData'
export default {
    name: 'GrowConversions',
    components: {
        GrowItem,
        SectionHeader
    },
    setup: function() {
        return {
            conversionData
        }
    }
}
</script>

<style lang="scss" scoped>
div.grow-conversation {
    padding-top: 130px;
    padding-bottom: 182px;
}
@media (max-width: 767px) {
div.grow-conversation {
    padding-top: 48px !important;
    padding-bottom: 56px;
}
}
@media (max-width: 1320px) {
    div.grow-item-container {
        justify-content: center !important;
        flex-direction: column;
    }
}
</style>